const CopyTooltip = () => {
  return (
    <span
      className="usa-tooltip__body usa-tooltip__body--right is-set is-visible"
      style={{ right: 0, marginRight: -75 }}
    >
      Copied!
    </span>
  );
};

export default CopyTooltip;
